var React = require('react');

function TickInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#000","strokeWidth":"2"},[React.createElement("ellipse",{"cx":"15.797","cy":"15.957","rx":"14.072","ry":"14.019","key":0}),React.createElement("polyline",{"strokeLinecap":"square","strokeLinejoin":"round","points":"10.773 18.11 14.448 20.963 20.821 10.95","key":1})]));
}

TickInline.defaultProps = {"viewBox":"0 0 31 31"};

module.exports = TickInline;

TickInline.default = TickInline;
